import { GET_PRODUCTS_CLEAR_STATE } from "constants-lib/actionTypes"

export const clearProductUrlState = () => ({
  type: GET_PRODUCTS_CLEAR_STATE,
})
